import { useNavigate } from 'react-router-dom';

import { AdminDemoDefiniton, } from '../../types';
import { Layout } from '../../components/layout';
import { useAuth } from 'react-oidc-context';
import { getEndpoint } from '../../utils';
import DemoForm from '../../components/admin/DemoForm';

export default function AddDemo() {
  const navigate = useNavigate();
  const auth = useAuth();


  const handleSubmit = async (demo: AdminDemoDefiniton) => {
    try {
      auth.startSilentRenew();
      const response = await fetch(getEndpoint('/api/admin/demos'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth?.user?.id_token}`,
        },
        body: JSON.stringify(demo)
      });
      console.log('Response:', response);
      const data = await response.json();
      console.log('Data:', data);
      if (response.ok) {
        navigate('/admin');
      }
    } catch (error) {
      console.error('Failed to save demo:', error);
    }
  };

  return (
    <Layout>
      <DemoForm onSubmit={handleSubmit} />
    </Layout>
  );
}
